
<div class="col-12 loader-background setBackgroundColor" *ngIf="isLoading">
  Loading Accumulation / Distribution order..
</div>
